import { render, staticRenderFns } from "./cusPurchaseStat.vue?vue&type=template&id=4d8dfe0e&scoped=true&"
import script from "./cusPurchaseStat.vue?vue&type=script&lang=js&"
export * from "./cusPurchaseStat.vue?vue&type=script&lang=js&"
import style0 from "./cusPurchaseStat.vue?vue&type=style&index=0&id=4d8dfe0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8dfe0e",
  null
  
)

component.options.__file = "cusPurchaseStat.vue"
export default component.exports